import axiosInst from "../../Config";
import { Decrypt_Value } from "../EncryptDecrypt";

const Pat_ID =
  localStorage.getItem("PID") &&
  Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

export const MembershipPlans_Api = async () =>
  await axiosInst.get(`/vozoportal/getMembershipPlans?pid=${Pat_ID}`);
